<!-- src/components/Footer.vue -->
<template>
    <footer>
      <div class="d-flex justify-content-center gap-xl-0 gap-1 w-100 flex-column-mobile"> 
        <!-- <div class="col-xl-4 col-12">
          <a href="/sixnes-erwtiseis-faq">Συχνές Ερωτήσεις (FAQ)</a>
        </div> -->
        <div class="col-xl-4 col-12">
          &copy; {{ currentYear }} My City Market | <span>Powered by <a href="https://citrine.gr/" target="_blank"> Citrine</a></span> | All rights reserved.
        </div>
        
      </div>
      
    </footer>
  </template>
  
  <script>
  export default {
    name: 'MainFooter',
    data() {
      return {
        currentYear: new Date().getFullYear()
      };
    }
  };
  </script>
  
  <style scoped>
    footer {
      background-color: #f0f0f0;
      padding: 5px;
      text-align: center;
      bottom: 0;
      width: 100%;
      z-index: 9999;
      font-size: 12px;
      position:fixed;
    }
    a:hover{
      color: #2776A0;
    }
  </style>